import React from 'react';
const Footer = () => {

  return (
    <div className='footer11' style={{}}>
        <p>
          AI جميع حقوق الملكية الفكرية محفوظة © مفيد
        </p>
        <a href="http://www.mrsgt.com/" style={{textDecoration:'none'}}>
          <p style={{color:"rgb(74,153,233)"}}>
            برمجة محمد معاذ تللو للحلول التقنية
          </p>  
        </a> 
    </div>
  )
}

export default Footer;